
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uk/privacy-policy",
      function () {
        return require("private-next-pages/uk/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uk/privacy-policy"])
      });
    }
  